module.exports = __webpack_public_path__ + "static/media/descriptionplaceholder3.f062f617.png";